/* jshint es3:true */
/**
 * Sets up the required bindings for a given set of DOM elements for a rating.
 * @param ratingLocation the parent DIV of the rating UI DOM elements as a JQuery object.
 */
function setupRating(ratingLocation) {
    var numericRating = $('.rating-selection', ratingLocation);
    resetRated();

    // Highlight the rating stars as they are hovered over.
    var ratingStars = $('.star', ratingLocation);
    ratingStars.hover(function() {
        var self = $(this);
        numericRating.text(getRating(self));
    });
    // Reset the rating stars highlighting to what has already been selected when the user moves away.
    $('.rating', ratingLocation).mouseout(resetRated);

    // Called from dialog.open, therefore unbind before binding.
    ratingStars.unbind('click');

    // Record the selected rating ready for document submission.
    ratingStars.click(function() {
        var self = $(this);
        var rating = getRating(self);
        // Record the rating for use when resetting the stars after hover.
        numericRating.attr('data-rated', rating);
        // Highlight the selected number of stars.
        ratingStars.removeClass('rated');
        self.add(self.nextAll()).addClass('rated');
        // Record the selected rating in the form.
        $('#ratingValue').val(rating);
    });

    function getRating(star) {
        return parseInt(ratingStars.length - star.prevAll().length, 10);
    }

    // Reset the star highlighting either to the previously selected rating or to an unset state.
    function resetRated() {
        var rated = numericRating.attr('data-rated');
        if ($i.isEmpty(rated)) {
            numericRating.text('?');
        } else {
            numericRating.text(rated);
        }
    }
}

$(function() {
    setupRating($('#rating'));
});
